<template>
  <!-- Design-system look: the bell and the user menu at the right end of the page's headline row
       (PageHeader, SectionTabs), where the eye looks for them. They are top right on every page:
       one without a headline row floats this same component on its line instead (Default.vue).
       On a phone too, so they are in the same place at every width; the title beside them wraps
       instead of pushing them down (PageHeader, SectionTabs). -->
  <div
    class="ml-auto flex flex-none items-center gap-2"
    data-test="header-actions"
  >
    <!-- Marketplace (SN-014): top right, before the bell, only while the company has the module.
         Opened from an event, the event is carried so offers keep that context. -->
    <Link
      v-if="marketplace"
      :href="marketplaceHref"
      class="flex h-[38px] items-center gap-2 rounded-(--ds-radius-pill) border-[1.5px] px-3.5 text-[14px] font-medium no-underline transition-colors duration-150 lg:h-[42px] lg:px-4"
      :class="
        onMarketplace
          ? 'border-(--ds-border-brand) text-(--ds-text-brand)'
          : 'border-(--ds-border-default) bg-(--ds-surface-default) text-(--ds-text-primary) hover:border-(--ds-border-brand) hover:text-(--ds-text-brand)'
      "
      :aria-current="onMarketplace ? 'page' : undefined"
      data-test="header-marketplace"
    >
      <img
        :src="Vapor.asset('images/ds-illustrations/marketplace.svg')"
        alt=""
        class="size-[18px]"
      />
      <span class="max-sm:sr-only" v-text="$t('marketplace.title')" />
    </Link>

    <Notifications
      menu-class="flex"
      menu-btn-class="flex! size-[38px]! lg:size-[42px]! items-center justify-center rounded-full! bg-(--ds-action-brand) py-0! text-(--ds-color-white) transition-colors duration-150 hover:bg-(--ds-color-violet-d300)"
      dropdown-class="right-0! top-full mt-2 origin-top-right rounded-(--ds-radius-md)! border border-(--ds-border-app) shadow-(--ds-elevation-overlay)! ring-0! max-lg:fixed max-lg:top-[72px] max-lg:right-4! max-lg:left-[76px] max-lg:mt-0 max-lg:w-auto!"
    />

    <UserDropdown in-header />
  </div>
</template>

<script setup>
import Notifications from '@/Components/Notifications/Notifications.vue'
import UserDropdown from '@/Components/UserSettings/UserDropdown.vue'
import { useFeature } from '@/composables/feature'
import { useRoute } from '@/composables/route'
import { Link, usePage } from '@inertiajs/vue3'
import Vapor from 'laravel-vapor'
import { computed } from 'vue'

const marketplace = computed(() => Boolean(useFeature('marketplace')))
const onMarketplace = computed(() =>
  usePage().component.startsWith('Marketplace/'),
)
const marketplaceHref = computed(() => {
  const event = usePage().props.event
  return useRoute('marketplace.index', event?.id ? { event: event.id } : {})
})
</script>
